import { Route, Routes } from 'react-router-dom'
import { ServersPage } from './pages/ServersPage'
import { HomePage } from './pages/HomePage'
import { ItemsPage } from './pages/ItemsPage'
import { Page404 } from './pages/404'
import { DashboardPage } from './pages/DashboardPage'
import { ProfilePage } from './pages/ProfilePage'
import { PremiumPage } from './pages/PremiumPage'
import { LoginPage } from './pages/LoginPage'
import { ConfigProvider, theme } from 'antd'
import { ThemeContext } from './contexts/theme'
import { useContext } from 'react'
import botconfig from './botconfig'
import ruRU from 'antd/locale/ru_RU'
import enUS from 'antd/locale/en_US'
import { LanguageContext } from './contexts/language'
function App() {
  const [ language ] = useContext(LanguageContext)
  const [ Theme ] = useContext(ThemeContext)
  return (
      <ConfigProvider locale={language === "ru" ? ruRU : enUS} theme={{
          algorithm: Theme === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm,
          token: {
            colorPrimary: "#ffb246",
            colorBgBase: Theme === "dark" ? "#313338" : "#FFFFFF",
          },
          components: {
            Form: {
              verticalLabelPadding: "0 0 0px"
            }
          }
      }}>
        <Routes>
          <Route path="/" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><HomePage/></div>} />
          <Route path="/servers" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><ServersPage /></div>} />
          <Route path="/dashboard/:guildId" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><DashboardPage /></div>} />
          {/* <Route path="/dashboard/:guildId/items" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><ItemsPage /></div>} /> */}
          <Route path="/*" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><Page404 /></div>} />
          <Route path="/guilds/:guildId/profiles/:userId" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><ProfilePage /></div>} />
          <Route path="/dashboard/:guildId/premium" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><PremiumPage /></div>} />
          <Route path="/login" element={<div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--bg-primary)" }} data-theme={Theme}><LoginPage /></div>} />
        </Routes>
      </ConfigProvider>
  )
}
export default App;
